import React from 'react';
import ComparisonContent from 'components/portfolio-comparison/ComparisonContent';
import ComparisonHeader from 'components/portfolio-comparison/ComparisonHeader';
import { useQueryParams } from 'global/hooks/useQuery';
import { ComparisonPageType, isPageType } from 'store/ui-stores/comparison/comparisonStore';
import Disclaimer from 'components/common/general/Disclaimer';
import ConfigComparisonContent from 'components/portfolio-comparison/ConfigComparisonContent';
import { createStyles } from '../../globalStyles';

const ComparePortfoliosPage = (): JSX.Element => {
  const classes = createStyles();
  const query = useQueryParams();

  const type = query.get('type') || null;
  if (!type || !isPageType(type)) {
    window.location.href = '/error-404';
  }

  const contentType = (): JSX.Element => {
    const pageType = type as ComparisonPageType;
    switch (pageType) {
      case 'config-portfolio':
        return <ConfigComparisonContent type={pageType} />;
      default:
        return <ComparisonContent type={pageType} />;
    }
  };

  return (
    <div className={classes.widePageWrapper}>
      <ComparisonHeader type={type as ComparisonPageType} />
      {contentType()}
      <Disclaimer />
    </div>
  );
};

export default ComparePortfoliosPage;
